import { createContext, useContext, useState } from 'react'

type State = {
  handleOpenHamburgerMenu: () => void
  isHamburgerMenuOpen: boolean
}

type TopBarProviderProps = { children: React.ReactNode }

export const TopBarContext = createContext<State | undefined>(undefined)

function TopBarProvider({ children }: TopBarProviderProps) {
  const [isHamburgerMenuOpen, setHamburgerMenuOpen] = useState(false)

  const handleOpenHamburgerMenu = () => {
    setHamburgerMenuOpen((prevHamburgerMenuOpen) => !prevHamburgerMenuOpen)
  }

  return (
    <TopBarContext.Provider
      value={{
        isHamburgerMenuOpen,
        handleOpenHamburgerMenu,
      }}
    >
      {children}
    </TopBarContext.Provider>
  )
}

function useTopBar() {
  const context = useContext(TopBarContext)
  if (context === undefined) {
    throw new Error('useTopBar must be used within a TopBarProvider')
  }
  return context
}

export { TopBarProvider, useTopBar }
